import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.watchlist-rename-modal {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 4px;
    font-family: 'Nimbus Sans Reg', sans-serif;
    padding: calc(8px * 2);
}
.modal-title {
    font-family: 'Nimbus Sans Bold', sans-serif;
    font-size: 20px;
}
.rename-input {
    width: 100%;
    background: #ffffff;
    border: 1px solid #086ea1;
    border-radius: 4px;
    font-size: 16px;
    line-height: 22px;
    padding: 6px;
    margin: calc(8px * 2) 0;
}
.action-buttons {
    display: flex;
    justify-content: center;
}
.save-button {
    color: #ffffff;
    background-color: #086ea1;
}
.action-buttons :global(.disabled) {
    opacity: 0.3;
    cursor: not-allowed;
}
@media (min-width: 722px) {
    .action-buttons {
        justify-content: flex-end;
    }
}
button {
    border: 1px solid #086ea1;
    border-radius: 5px;
    width: 100px;
    height: 40px;
    font-size: 16px;
    text-align: center;
}
button:hover {
    cursor: pointer;
}
button:not(:last-child) {
    margin-right: 8px;
}
@media (min-width: 722px) {
    .watchlist-rename-modal {
        max-width: 540px;
        padding: calc(8px * 4);
    }
}
`;

export default styles;